module.exports = __webpack_public_path__ + "img/point_state_6.png";